// destructuring doesn't work poperly with process.env
/* eslint-disable prefer-destructuring */

import { routes } from 'utils/routes';

export const SEARCH_ARTICLES_LIMIT = 50;
export const HOMEPAGE_ARTICLES_LIMIT = 4;
export const ARTICLES_NUMBER_PER_PAGE = 11;
export const ARTICLES_NUMBER_PER_PERSON_PAGE = 7;
export const HOMEPAGE_BLOG_CURRENT_PAGE = 1;
export const ARTICLE_PHOTO_GALLERY_IMAGES_PER_LINE = 3;
export const ROUTES = { ...routes };

export const ACCESS_TO_CONTENTFUL = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENV,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_TOKEN,
};

export const ACCESS_TO_CONTENTFUL_PREVIEW = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENV,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_TOKEN,
  isPreview: true,
};

export const ACCESS_TO_CONTENTFUL_BLOG = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_SPACE,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_ENV,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_TOKEN,
};

export const ACCESS_TO_CONTENTFUL_BLOG_PREVIEW = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_SPACE,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_ENV,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_BLOG_PREVIEW_TOKEN,
  isPreview: true,
};

export const ACCESS_TO_CONTENTFUL_FALLBACK = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_FALLBACK_SPACE,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_FALLBACK_ENV,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_FALLBACK_TOKEN,
};

export const PAGES = Object.entries(routes)
  .reduce((acc, [key, { slug }]) => {
    acc[key] = slug;

    return acc;
  }, {});

export const INTERACTIVE_LINKS = {
  aiTransformation: {
    title: 'AI Transformation',
    slug: 'aiTransformation',
    path: '/artificial-intelligence-development-services',
  },
  services: {
    title: 'Services',
    slug: 'services',
    path: '/services',
  },
  works: {
    title: 'Works',
    slug: 'works',
    path: '/works',
  },
  company: {
    title: 'Company',
    slug: 'company',
    path: '/company',
  },
};

export const INTERACTIVE_LINKS_MOBILE = {
  company: {
    title: 'Company',
    slug: 'company',
    path: '/company',
  },
};

export const TAGS_TYPE = {
  dark: 'dark',
  light: 'light',
  category: 'category',
};

export const NAV_LINKS = [
  INTERACTIVE_LINKS.aiTransformation,
  INTERACTIVE_LINKS.services,
  INTERACTIVE_LINKS.works,
  INTERACTIVE_LINKS.company,
];

export const BLOCKS_SLUGS = {
  homepagePreviewProjects: 'homepage-preview-projects',
  worksPagePreviewProjects: 'works-page-preview-projects',
  imageCarousel: 'image-carousel',
  companyPageWhatMakesSpecial: 'company-page-what-makes-us-special',
  compnayPageManagementTeam: 'company-page-management-team',
  contactPageCompanyPhoto: 'contact-page-company-photo',
  processPageProcessPreview: 'process-page-process-preview',
  companyReviews: 'company-reviews',
};

export const ANIMATED_TYPE = {
  isReveal: 'isReveal',
  isFade: 'isFade',
  isCustom: 'isCustom',
  isJSON: 'isJSON',
  isParallaxSpring: 'isParallaxSpring',
  gsap: 'gsap',
  imageZoom: 'imageZoom',
  expandByHeight: 'expandByHeight',
  isCSS: 'isCSS',
  bounce: 'bounce',
  counter: 'counter',
  zoomOut: 'zoomOut',
};

export const CATEGORY_TAGS = Object.entries(routes.blog.categories)
  .reduce(
    (acc, [_, {
      slug,
      title,
    }]) => {
      acc[slug] = title;

      return acc;
    },
    {},
  );

export const CATEGORY_SLUGS = Object.entries(routes.blog.categories)
  .reduce(
    (acc, [key, { slug }]) => {
      acc[key] = slug;

      return acc;
    },
    [],
  );

export const FEEDBACK_FORM_FIELDS = {
  name: 'name',
  email: 'email',
  description: 'description',
  isSendNDAChecked: 'isSendNDAChecked',
  projectBudget: 'projectBudget',
  attachments: 'attachments',
  clientId: 'clientId',
  source: 'source',
  medium: 'medium',
  phone: 'phone',
  city: 'city',
  clientCityRegion: 'clientCityRegion',
  clientCountry: 'clientCountry',
};

export const IMAGES = {
  roundLogo: '/images/common/logo/yellow_logo.svg',
  logoWhite: '/images/common/logo/logoWhite.svg',
  unpinFile: '/images/common/upload/unpin.svg',
  dashedLine: '/images/common/dashedLine.png',
  advantagesIcons: {
    ai: '/images/home/advantages/ai.svg',
    chats: '/images/home/advantages/chats.svg',
    cloud: '/images/home/advantages/cloud.svg',
    mobile: '/images/home/advantages/mobile.svg',
  },
  reviewsImages: {
    Ian: '/images/home/reviews/1.png',
    Jim: '/images/home/reviews/2.png',
    Sandro: '/images/home/reviews/3.png',
    Jerry: '/images/home/reviews/4.png',
  },
};

export const SVG_IMAGES_TYPES = {
  arrowRight: 'arrowRight',
  arrowLeft: 'arrowLeft',
  arrowNarrowDown: 'arrowNarrowDown',
  arrow: 'arrow1',
  bookmarkArrow: 'bookmarkArrow',
  bookmarkIcon: 'bookmarkIcon',
  bookOpenFilled: 'bookOpenFilled',
  nearbyArrow: 'nearbyArrow',
  chevronDown: 'chevronDown',
  appstore: 'appstore',
  blackFillAppstore: 'blackFillAppstore',
  blackLogo: 'blackLogo',
  defaultLogo: 'defaultLogo',
  whiteLogo: 'whiteLogo',
  blackYellowText: 'blackYellowText',
  whiteYellowText: 'whiteYellowText',
  arrowNarrowUp: 'arrowNarrowUp',
  mediumFilledWhite: 'mediumFilledWhite',
  linkedinFilledWhite: 'linkedinFilledWhite',
  twitterFilledWhite: 'twitterFilledWhite',
  behanceFilled: 'behanceFilled',
  behanceFilledWhite: 'behanceFilledWhite',
  mediumFilled: 'mediumFilled',
  instagramFilled: 'instagramFilled',
  instagramFilledWhite: 'instagramFilledWhite',
  dribbbleFilledWhite: 'dribbbleFilledWhite',
  dribbbleFilled: 'dribbbleFilled',
  searchLg: 'searchLg',
  closeSvg: 'xClose',
  attachment: 'attachment',
  opensenseTitleBorder: 'opensenseTitleBorder',
  checkMark: 'checkMark',
  checkMarkWhite: 'checkMarkWhite',
  check: 'check',
  iPhone: 'iPhone',
  iPad: 'iPad',
  arrowDown: 'arrowDown',
  youtubeFilledWhite: 'youtubeFilledWhite',
  rocketFilled: 'rocketFilled',
  playBold: 'playBold',
  pauseBold: 'pauseBold',
  usersGroup: 'usersGroup',
  globe02: 'globe02',
  tubeBroken: 'tubeBroken',
};

export const APP_DEVELOPMENT_TYPES = {
  appDevelopmentPageIntro: 'app-development-page-intro',
  appDevelopmentCards: 'app-development-cards',
  appDevelopmentCheckList: 'app-development-check-list',
  appDevelopmentSvgList: 'app-development-svg-list',
  appDevelopmentGallery: 'app-development-gallery',
  appDevelopmentFAQ: 'app-development-faq',
  appDevelopmentSlider: 'app-development-slider',
  appDevelopmentImageSection: 'app-development-image',
  appDevelopmentReviews: 'app-development-reviews',
  appDevelopmentImagesList: 'app-development-images-list',
  appDevelopmentNumberedList: 'app-development-numbered-list',
  appDevelopmentProcess: 'app-development-process',
  appDevelopmentBlog: 'app-development-blog',
  appDevelopmentCheckSocial: 'app-development-check-social',
  appDevelopmentRelatedServices: 'app-development-related-services',
  svgDisplayWithSelector: 'svg-display-with-selector',
  cardsWithOverlay: 'cards-with-overlay',
  appDevelopmentAppFeatures: 'app-development-app-features',
  appDevelopmentAppFeaturesPromo: 'app-development-app-features-promo',
  appDevelopmentPlainTextSection: 'app-development-plain-text',
  appDevelopmentBookmarkCard: 'app-development-bookmark-card',
  appDevelopmentTabsSection: 'app-development-tabs-section',
  processOverlay: 'app-development-process-overlay',
  appDevelopmentSliderCards: 'app-development-slider-cards-section',
  appDevelopmentDownloadSection: 'app-development-download-section',
  appDevelopmentTableSection: 'app-development-table-section',
  feedback: 'feedback',
  parallax: 'case-study-parallax',
  softwarePriceForm: 'software-price-form',
  team: 'accordion-card-stack',
  wireframes: 'case-study-wireframe',
  infinityScrollingCarousel: 'infinityScrollingCarousel',
  videosGallery: 'videos-gallery',
  cardsSlider: 'cards-slider',
  svgList: 'svg-list',
  tableSection: 'table-section',
  tableCalculator: 'table-calculator',
};

export const WHY_US_TYPE = {
  intro: 'case-study-intro',
  parallax: 'case-study-parallax',
  svgList: 'svg-display',
  imageSection: 'app-development-image',
  feedback: 'feedback',
  process: 'case-study-process',
  imagesSection: 'case-study-image',
  challenges: 'case-study-challenges',
  tabs: 'app-development-tabs-section',
  gallery: 'app-development-gallery',
  results: 'case-study-results',
};

export const HOMEPAGE_SLOGAN = 'WE KICK ASS WITH AI';

export const HOMEPAGE_SECTION_TYPES = {
  text: 'text',
  cards: 'cards',
  cardsWithOverlay: 'cards-with-overlay',
  svgDisplay: 'svg-display',
  svgDisplayWithSelector: 'svg-display-with-selector',
  portfolio: 'portfolio',
  reviews: 'reviews',
  blog: 'blog',
  photos: 'photos',
  feedback: 'feedback',
  team: 'accordion-card-stack',
  infinityScrollingCarousel: 'infinityScrollingCarousel',
  cardsSlider: 'cards-slider',
  svgList: 'svg-list',
  card: 'card',
  scrollingTabs: 'scrolling-tabs',
  cta: 'cta',
  appDevelopmentPageIntro: 'app-development-page-intro',
  caseProcess: 'case-study-process',
  images: 'case-study-image',
  youtubeVideos: 'youtube-videos',
  youtubeVideosWithSlider: 'youtube-videos-slider',
};

export const DEFAULT_DATE_FORMAT = 'MMMM D, YYYY';

export const HEADER_HEIGHT = 66;

export const CASE_STUDIES_TYPES = {
  intro: 'case-study-intro',
  projectIdea: 'case-study-project-idea',
  challenges: 'case-study-challenges',
  specialChallenges: 'case-study-special',
  wireframe: 'case-study-wireframe',
  appFeatures: 'case-study-app-features',
  image: 'case-study-image',
  results: 'case-study-results',
  parallax: 'case-study-parallax',
  design: 'case-study-design',
  features: 'case-study-features',
  story: 'case-study-story',
  caseStudyEvent: 'case-study-event',
  fullscreenImage: 'case-study-fullscreen-image',
  works: 'case-study-how-it-works',
  challengesSlider: 'case-study-challenges-slider',
  processOverlay: 'case-study-process-overlay',
  challengesSpecialSlider: 'case-study-special-slider',
  prototype: 'case-study-prototype',
  feedback: 'feedback',
  process: 'case-study-process',
  cardsWithOverlay: 'cards-with-overlay',
  cards: 'cards',
  processWithArrays: 'app-development-process',
  tabs: 'app-development-tabs-section',
  faq: 'case-study-faq',
  plainTextSection: 'app-development-plain-text',
  accordionCards: 'accordion-card-stack',
  twoBlockChallanges: 'two-block-challanges',
  slider: 'app-development-slider',
};

export const SECTION_TYPES = {
  intro: 'case-study-intro',
  personIntro: 'person-intro',
  caseProcess: 'case-study-process',
  images: 'case-study-image',
  tabs: 'app-development-tabs-section',
  parallax: 'case-study-parallax',
  photos: 'photos',
  review: 'app-development-reviews',
  appDevelopmentCards: 'app-development-cards',
  appDevelopmentProcess: 'app-development-process',
  appDevelopmentSvgList: 'app-development-svg-list',
  svgList: 'svg-list',
  cardsSlider: 'cards-slider',
  portfolio: 'portfolio',
  cards: 'cards',
  card: 'card',
  blog: 'blog',
  cta: 'cta',
  pageIntro: 'app-development-page-intro',
  faq: 'app-development-faq',
  plainTextSection: 'app-development-plain-text',
  youtubeVideos: 'youtube-videos',
  assessmentSection: 'assessment-section',
};

export const ARTICLE_PREVIEW_TYPES = {
  related: 'related',
  blog: 'blog',
  search: 'search',
};

export const CASE_STUDIES = {
  fernwayer: 'fernwayer',
  dindon: 'dindon',
  stickerbox: 'stickerbox',
  hotelDataCloud: 'hotel-data-cloud',
  sevenPmThursday: 'seven-pm-thursday',
  fairy: 'fairy',
  tell: 'tell',
  openSense: 'open-sense',
  writerChromeExtension: 'writer-chrome-extension',
  separateUs: 'separate-us',
  natp: 'natp',
  driveFocus: 'drive-focus',
  cashChat: 'cash-chat',
  travelTrivia: 'travel-trivia',
  beautonomy: 'beautonomy',
  smartcenter: 'smartcenter',
  telemojo: 'telemojo',
  ubiChat: 'ubichat',
  meatEater: 'meateater',
  fireaway: 'fireaway',
  famlicious: 'famlicious',
  bionorica: 'bionorica',
  fusionMarkets: 'fusion-markets',
  blackBird: 'blackbird',
  mobileFintechApp: 'fintech-app-for-credit-score',
  goodPsychics: 'marketplace-for-clairvoyant-services',
  mlInRealEstate: 'machine-learning-in-real-estate',
  humankind: 'humankind',
  balzano: 'software-for-mri-interpretation',
  cinnabar: 'cinnabar',
  mobileBankApplication: 'mobile-bank-application',
  cedar: 'cedar-valley-farms',
  mobileBudgetingApp: 'mobile-budgeting-app',
  forexTradingPlatform: 'forex-trading-platform',
  crowdfundingPlatform: 'crowdfunding-platform',
  metapix: 'cctv-footage-analytics',
  carbonSpace: 'analytics-for-carbon-tracking',
  p2pLoans: 'web-p2p-lending-platform',
  chatSolutions: 'web-chat-for-mediums',
  kitchenEquipment: 'kitchen-equipment-customizer',
  radioPlato: 'mobile-music-app',
  clairvoyantServices: 'clairvoyant-directory-upgrade',
  digitalWallet: 'digital-wallet-for-ios',
  erp: 'enterprise-resource-planning-system',
  hawkin: 'medical-software-for-musculoskeletal-rehabilitation',
  hyve: 'restaurant-asset-management-tool',
  paymentGateway: 'custom-payment-gateway',
  generativeAi: 'ai-documentation-processing',
  tasteMatch: 'ai-mobile-cooking-app',
  aiBasedTravelPlanner: 'ai-based-travel-planner',
  aiStreamlinedRecruitmentProcess: 'ai-streamlined-recruitment-process',
  writerFrameworkPlatform: 'writer-framework-platform',
  computerVisionForAras: 'computer-vision-for-aras',
  aiPoweredComplianceTool: 'enhancing-money-laundering-mention-extraction',
  penetrationTestingForHealthtechCompany: 'penetration-testing-for-healthtech-company',
  penTestingForUKWebDevCompany: 'pen-testing-for-uk-web-dev-company',
  penTestsAi: 'pen-tests-ai',
  webLogistics: 'web-logistics-platform',
  llmDocument: 'llm-legal-document-summarization',
  fintechAnalysis: 'ai-feedback-analysis',
  aiEdtech: 'ai-for-edtech',
  aiReporting: 'ai-reporting-assistant',
  automatingClaims: 'llm-for-insurtech-saas',
  feedbackEngine: 'feedback-insight-engine',
  aiMarketing: 'predictive-ai-for-marketing',
  aiPreScreening: 'ai-agent-for-pre-screening',
  aiConcierge: 'ai-concierge-for-hotel-network',
  aiVoiceAssistant: 'ai-voice-assistant-for-e-learning',
  aiAssistantPatients: 'ai-assistant-for-chronic-patients',
  warehouseAgent: 'ai-warehouse-agent',
  ragPlatform: 'rag-contract-intelligence-platform',
  claudeSonnet: 'claude-sonnet-leasing-operations-platform',
  databaseUi: 'influx',
  futurepay: 'futurepay',
  commod: 'commod',
};

export const CASE_STUDIES_SLUGS = Object.entries(CASE_STUDIES)
  .reduce(
    (acc, [key, value], index) => {
      acc[index] = value;

      return acc;
    },
    [],
  );

export const NEW_PERSON = {
  dmitry: 'dmitry',
  vlad: 'vlad',
  sofia: 'sofia',
  mikita: 'mikita',
  yana: 'yana',
  lika: 'lika',
  nastassia: 'nastassia',
};

export const NEW_PERSON_SLUGS = Object.entries(NEW_PERSON)
  .reduce(
    (acc, [key, value], index) => {
      acc[index] = value;

      return acc;
    },
    [],
  );

export const PAGES_WITH_DARK_HEADER = [
  ROUTES.project.getRoute(CASE_STUDIES.balzano).path,
  ROUTES.project.getRoute(CASE_STUDIES.fernwayer).path,
  ROUTES.project.getRoute(CASE_STUDIES.dindon).path,
  ROUTES.project.getRoute(CASE_STUDIES.stickerbox).path,
  ROUTES.project.getRoute(CASE_STUDIES.sevenPmThursday).path,
  ROUTES.project.getRoute(CASE_STUDIES.fairy).path,
  ROUTES.project.getRoute(CASE_STUDIES.natp).path,
  ROUTES.project.getRoute(CASE_STUDIES.driveFocus).path,
  ROUTES.project.getRoute(CASE_STUDIES.cashChat).path,
  ROUTES.project.getRoute(CASE_STUDIES.travelTrivia).path,
  ROUTES.project.getRoute(CASE_STUDIES.meatEater).path,
  ROUTES.project.getRoute(CASE_STUDIES.fireaway).path,
  ROUTES.project.getRoute(CASE_STUDIES.fusionMarkets).path,
  ROUTES.project.getRoute(CASE_STUDIES.blackBird).path,
  ROUTES.project.getRoute(CASE_STUDIES.mobileFintechApp).path,
  ROUTES.project.getRoute(CASE_STUDIES.goodPsychics).path,
  ROUTES.project.getRoute(CASE_STUDIES.mlInRealEstate).path,
  ROUTES.project.getRoute(CASE_STUDIES.cinnabar).path,
  ROUTES.project.getRoute(CASE_STUDIES.mobileBankApplication).path,
  ROUTES.project.getRoute(CASE_STUDIES.hotelDataCloud).path,
  ROUTES.project.getRoute(CASE_STUDIES.ubiChat).path,
  ROUTES.project.getRoute(CASE_STUDIES.writerChromeExtension).path,
  ROUTES.project.getRoute(CASE_STUDIES.telemojo).path,
  ROUTES.project.getRoute(CASE_STUDIES.smartcenter).path,
  ROUTES.project.getRoute(CASE_STUDIES.cedar).path,
  ROUTES.project.getRoute(CASE_STUDIES.mobileBudgetingApp).path,
  ROUTES.project.getRoute(CASE_STUDIES.forexTradingPlatform).path,
  ROUTES.project.getRoute(CASE_STUDIES.kitchenEquipment).path,
  ROUTES.project.getRoute(CASE_STUDIES.radioPlato).path,
  ROUTES.project.getRoute(CASE_STUDIES.clairvoyantServices).path,
  ROUTES.project.getRoute(CASE_STUDIES.erp).path,
  ROUTES.project.getRoute(CASE_STUDIES.hyve).path,
  ROUTES.project.getRoute(CASE_STUDIES.paymentGateway).path,
  ROUTES.project.getRoute(CASE_STUDIES.aiBasedTravelPlanner).path,
  ROUTES.project.getRoute(CASE_STUDIES.humankind).path,
  ROUTES.project.getRoute(CASE_STUDIES.crowdfundingPlatform).path,
  ROUTES.project.getRoute(CASE_STUDIES.metapix).path,
  ROUTES.project.getRoute(CASE_STUDIES.p2pLoans).path,
  ROUTES.project.getRoute(CASE_STUDIES.hawkin).path,
  ROUTES.project.getRoute(CASE_STUDIES.aiStreamlinedRecruitmentProcess).path,
  ROUTES.project.getRoute(CASE_STUDIES.writerFrameworkPlatform).path,
  ROUTES.project.getRoute(CASE_STUDIES.ragPlatform).path,
  ROUTES.project.getRoute(CASE_STUDIES.claudeSonnet).path,
  ROUTES.project.getRoute(CASE_STUDIES.databaseUi).path,
  ROUTES.project.getRoute(CASE_STUDIES.computerVisionForAras).path,
  ROUTES.project.getRoute(CASE_STUDIES.penTestsAi).path,
  ROUTES.project.getRoute(CASE_STUDIES.penTestingForUKWebDevCompany).path,
  ROUTES.customWebApp.path,
  ROUTES.homepage.path,
  ROUTES.whyUs.path,
  ROUTES.iosDevelopmentServices.path,
  ROUTES.fintechDevelopment.path,
  ROUTES.softwareQualityAssuranceServices.path,
  ROUTES.erpDevelopment.path,
  ROUTES.mvpDevelopment.path,
  ROUTES.androidDevelopmentServices.path,
  ROUTES.cloudDevelopment.path,
  ROUTES.mlDevelopment.path,
  ROUTES.prototypingServices.path,
  ROUTES.penetrationTesting.path,
  ROUTES.pwaDevelopmentServices.path,
  ROUTES.softwareDevelopmentColumbus.path,
  ROUTES.softwareDevelopmentWashington.path,
  ROUTES.softwareDevelopmentOklahoma.path,
  ROUTES.softwareDevelopmentNashville.path,
  ROUTES.softwareDevelopmentOmaha.path,
  ROUTES.softwareDevelopmentMiami.path,
  ROUTES.softwareDevelopmentMinneapolis.path,
  ROUTES.softwareDevelopmentTulsa.path,
  ROUTES.softwareDevelopmentNewOrleans.path,
  ROUTES.aiChatbotDevelopmentServices.path,
  ROUTES.aiStaffAugmentationServices.path,
  ROUTES.bookCall.path,
  ROUTES.deepLearning.path,
  ROUTES.aiConsulting.path,
  ROUTES.computerVisionServices.path,
  ROUTES.aiAgentsServices.path,
  ROUTES.assessments.path,
  `${ROUTES.assessments.path}#Assessments`,
  ROUTES.naturalLanguageProcessingAsAService.path,
  ROUTES.roboticProcessAutomationServices.path,
  ROUTES.softwareDevelopmentForStartups.path,
  ROUTES.ragDevelopment.path,
  ROUTES.aiManagedPod.path,
  ROUTES.mlOpsDevelopment.path,
];

export const CASE_STUDIES_PAGES_WITH_DEFAULT_HEADER = [];

export const PAGES_WITH_TRANSPARENT_HEADER = [
  ROUTES.homepage.path,
  ROUTES.customWebApp.path,
  ROUTES.iosDevelopmentServices.path,
  ROUTES.androidDevelopmentServices.path,
  ROUTES.softwareQualityAssuranceServices.path,
  ROUTES.mvpDevelopment.path,
  ROUTES.cloudDevelopment.path,
  ROUTES.mlDevelopment.path,
  ROUTES.fintechDevelopment.path,
  ROUTES.erpDevelopment.path,
  ROUTES.devOpsDevelopment.path,
  ROUTES.dataScienceDevelopment.path,
  ROUTES.aiDevelopment.path,
  ROUTES.webinar.path,
  ROUTES.webinarAi.path,
  ROUTES.webinarLLM.path,
  ROUTES.webinarDeployingAgent.path,
  ROUTES.crossPlatformDevelopmentServices.path,
  ROUTES.prototypingServices.path,
  ROUTES.pwaDevelopmentServices.path,
  ROUTES.softwareDevelopmentColumbus.path,
  ROUTES.softwareDevelopmentWashington.path,
  ROUTES.softwareDevelopmentOklahoma.path,
  ROUTES.softwareDevelopmentNashville.path,
  ROUTES.softwareDevelopmentRaleigh.path,
  ROUTES.softwareDevelopmentOmaha.path,
  ROUTES.softwareDevelopmentMiami.path,
  ROUTES.softwareDevelopmentMinneapolis.path,
  ROUTES.softwareDevelopmentTulsa.path,
  ROUTES.softwareDevelopmentNewOrleans.path,
  ROUTES.generativeAiDevelopment.path,
  ROUTES.deepLearning.path,
  ROUTES.aiChatbotDevelopmentServices.path,
  ROUTES.aiStaffAugmentationServices.path,
  ROUTES.aiConsulting.path,
  ROUTES.whyUs.path,
  ROUTES.bookCall.path,
  CASE_STUDIES.openSense,
  CASE_STUDIES.chatSolutions,
  CASE_STUDIES.kitchenEquipment,
  CASE_STUDIES.radioPlato,
  CASE_STUDIES.clairvoyantServices,
  CASE_STUDIES.hawkin,
  CASE_STUDIES.hyve,
  CASE_STUDIES.paymentGateway,
  CASE_STUDIES.computerVisionForAras,
  CASE_STUDIES.aiReporting,
  ROUTES.company.path,
  ROUTES.computerVisionServices.path,
  ROUTES.aiAgentsServices.path,
  ROUTES.assessments.path,
  `${ROUTES.assessments.path}#Assessments`,
  ROUTES.naturalLanguageProcessingAsAService.path,
  ROUTES.roboticProcessAutomationServices.path,
  ROUTES.softwareDevelopmentForStartups.path,
  ROUTES.logisticsSoftwareDevelopmentCompany.path,
  ROUTES.eCommerceDevelopment.path,
  ROUTES.travelAndHospitalDevelopment.path,
  ROUTES.educationalSoftwareDevelopment.path,
  ROUTES.entertainmentSoftwareDevelopment.path,
  ROUTES.healthcareDevelopment.path,
  ROUTES['software-development-engagement-models'].path,
  CASE_STUDIES.aiPoweredComplianceTool,
  ROUTES.aiVoiceAssistantDevelopment.path,
  ROUTES.ragDevelopment.path,
  ROUTES.aiManagedPod.path,
  ROUTES.mlOpsDevelopment.path,
];

export const PAGES_WITH_GRAY_HEADER = [
  ROUTES.penetrationTesting.path,
  ROUTES.eWalletAppDevelopment.path,
  ROUTES.bankingSoftwareDevelopmentCompany.path,
  ROUTES.deliveryQualityInYellow.path,
  ROUTES.paymentGatewayDevelopment.path,
  ROUTES.billingSoftwareDevelopment.path,
];

export const CASE_STUDIES_WITH_TRANSPARENT_HEADER = CASE_STUDIES_SLUGS.filter(
  (path) => !CASE_STUDIES_PAGES_WITH_DEFAULT_HEADER.includes(path),
);

export const SUB_NAVIGATION_KEYS = {
  services: 'services',
  solutions: 'solutions',
  expertise: 'expertise',
};

export const SUB_NAVIGATION_LINKS = {};

export const LINKS_WITH_SUB_NAVIGATION = [];

export const ARTICLE_TABLE_TYPES = {
  simpleTable: 'Simple table',
  tableWithHeader: 'Table with header',
  tableWithTwoHeader: 'Table with two headers',
};

export const PAGES_WITH_DARK_BREADCRUMBS = [
  PAGES.customMobileApp,
  PAGES.customChatApp,
  PAGES.designServices,
  PAGES.discoveryPhase,
  PAGES.tradingSoftwareDevelopment,
  PAGES.lendingSoftwareDevelopment,
  PAGES.penetrationTesting,
  PAGES.softwareDevelopmentPrice,
  PAGES.eWalletAppDevelopment,
  PAGES.bankingSoftwareDevelopmentCompany,
  PAGES.deliveryQualityInYellow,
  PAGES.crowdfundingPlatform,
  PAGES.paymentGatewayDevelopment,
  PAGES.billingSoftwareDevelopment,
  PAGES.aiSoftwareDevelopmentServices,
  PAGES.softwareDevelopmentServicesForVariousIndustries,
  PAGES.softwareDevelopmentServicesForTechBusinesses,
  PAGES.logisticsSoftwareDevelopmentCompany,
  PAGES.eCommerceDevelopment,
  PAGES.travelAndHospitalDevelopment,
  PAGES.educationalSoftwareDevelopment,
  PAGES.entertainmentSoftwareDevelopment,
  PAGES.healthcareDevelopment,
  PAGES['software-development-engagement-models'],
  PAGES.llmDevelopment,
  PAGES.aiVoiceAssistantDevelopment,
  PAGES.aiCopilot,
  PAGES.services,
  PAGES.search,

  // CASE STUDIES
  CASE_STUDIES.tell,
  CASE_STUDIES.openSense,
  CASE_STUDIES.separateUs,
  CASE_STUDIES.beautonomy,
  CASE_STUDIES.famlicious,
  CASE_STUDIES.bionorica,
  CASE_STUDIES.carbonSpace,
  CASE_STUDIES.chatSolutions,
  CASE_STUDIES.digitalWallet,
  CASE_STUDIES.generativeAi,
  CASE_STUDIES.tasteMatch,
  CASE_STUDIES.penetrationTestingForHealthtechCompany,
  CASE_STUDIES.webLogistics,
  CASE_STUDIES.llmDocument,
  CASE_STUDIES.fintechAnalysis,
  CASE_STUDIES.aiEdtech,
  CASE_STUDIES.automatingClaims,
  CASE_STUDIES.feedbackEngine,
  CASE_STUDIES.aiMarketing,
  CASE_STUDIES.aiPreScreening,
  CASE_STUDIES.aiConcierge,
  CASE_STUDIES.aiVoiceAssistant,
  CASE_STUDIES.aiAssistantPatients,
  CASE_STUDIES.futurepay,
  CASE_STUDIES.commod,
  CASE_STUDIES.warehouseAgent,
];

export const DEFAULT_WORK_TYPE = {
  slug: 'all',
  displayName: 'All',
};
export const DEFAULT_WORKS_LIMIT = 9;

export const WORK_TYPES = {
  all: 'All',
  mobile: 'Mobile development',
  uiUx: 'UI/UX design',
  chat: 'Chat development',
  web: 'Web development',
  aiMl: 'AI & ML',
};

export const SWIPER_NAV_BUTTON_TYPES = {
  next: 'next',
  prev: 'prev',
};

export const REVEAL_ANIMATION_PROPS = {
  type: ANIMATED_TYPE.isCustom,
  translateY: '2.8em',
  opasityDuration: 0.5,
  transformDuration: 0.7,
  transitionDelay: 50,
};

export const BOUNCE_ANIMATION_PROPS = {
  type: ANIMATED_TYPE.bounce,
  right: 'right',
  duration: 1000,
  ssrFadeout: 'ssrFadeout',
};

export const PHONE_RESOLUTION = 568;
export const HORIZONTAL_MOBILE = 450;
export const DEFAULT_TABLET_RESOLUTION = 768;
export const BIG_TABLET_RESOLUTION = 1024;
export const FULL_HD_RESOLUTION = 1920;

// export const DEV_HOSTS = ['www.yws-dev.xyz', 'yws-dev.xyz'];

export const CUSTOM_DOMAIN = process.env.NEXT_PUBLIC_CUSTOM_DOMAIN;

export const IS_PROD = process.env.NEXT_PUBLIC_CURRENT_ENV === 'production';

export const INDEX_FILES = [
  '/index.asp',
  '/index.aspx',
  '/index.htm',
  '/index.html',
  '/index.php',
];

export const VALUABLE_ARTICLE_CATEGORIES_SLUGS = [
  'fintech',
  'yellow',
  'how-we-work',
  'software-development',
  'software-chat',
  'marketing',
];

export const PAGES_WITHOUT_INDEXING = [
  ROUTES.aiSoftwareDevelopmentServices.path,
];

export const PAGES_EXCLUDE_SEARCH = [
  ROUTES.homepage.slug,
  ROUTES.portfolio.slug,
  ROUTES.webinar.slug,
  ROUTES.webinarAi.slug,
  ROUTES.webinarLLM.slug,
  ROUTES.webinarDeployingAgent.slug,
  ROUTES.process.slug,
  ROUTES.softwareDevelopmentPrice.slug,
  ROUTES.blog.slug,
  ROUTES.search.slug,
  ROUTES.company.slug,
  ROUTES.whyUs.slug,
  ROUTES.contact.slug,
  ROUTES.services.slug,
  ROUTES.signatureGenerator.slug,
  ROUTES.privacyPolicy.slug,
  ROUTES.termsAndConditions.slug,
  ROUTES.contentRules.slug,
  ROUTES.deliveryQualityInYellow.slug,
  ROUTES.bookCall.slug,
  ROUTES.cookiesPolicy.slug,
  ROUTES.notFound.slug,
];

export const PAGES_FALLBACK_CONTENTFUL = [
  ROUTES.naturalLanguageProcessingAsAService.slug,
  ROUTES.healthcareDevelopment.slug,
  ROUTES.aiStaffAugmentationServices.slug,
  ROUTES.search.slug,
  ROUTES.computerVisionServices.slug,
  ROUTES.logisticsSoftwareDevelopmentCompany.slug,
  CASE_STUDIES.automatingClaims,
  ROUTES.llmDevelopment.slug,
  ROUTES.aiAgentsServices.slug,
  ROUTES.homepage.slug,
  ROUTES.services.slug,
  ROUTES.aiCopilot.slug,
  ROUTES.contentRules.slug,
  ROUTES.aiVoiceAssistantDevelopment.slug,
  CASE_STUDIES.aiAssistantPatients,
  CASE_STUDIES.ragPlatform,
  CASE_STUDIES.claudeSonnet,
  CASE_STUDIES.databaseUi,
  CASE_STUDIES.futurepay,
  CASE_STUDIES.commod,
  CASE_STUDIES.aiVoiceAssistant,
  ROUTES.webinarAi.slug,
  ROUTES.webinarLLM.slug,
  ROUTES.webinarDeployingAgent.slug,
  CASE_STUDIES.aiConcierge,
  CASE_STUDIES.aiPreScreening,
  CASE_STUDIES.aiMarketing,
  ROUTES.webinar.slug,
  CASE_STUDIES.feedbackEngine,
  CASE_STUDIES.aiReporting,
  CASE_STUDIES.aiEdtech,
  CASE_STUDIES.fintechAnalysis,
  CASE_STUDIES.llmDocument,
  CASE_STUDIES.webLogistics,
  CASE_STUDIES.computerVisionForAras,
  ROUTES['software-development-engagement-models'].slug,
  CASE_STUDIES.penTestsAi,
  CASE_STUDIES.penTestingForUKWebDevCompany,
  CASE_STUDIES.penetrationTestingForHealthtechCompany,
  ROUTES.entertainmentSoftwareDevelopment.slug,
  ROUTES.educationalSoftwareDevelopment.slug,
  ROUTES.travelAndHospitalDevelopment.slug,
  CASE_STUDIES.aiPoweredComplianceTool,
  ROUTES.eCommerceDevelopment.slug,
  CASE_STUDIES.writerFrameworkPlatform,
  ROUTES.softwareDevelopmentServicesForVariousIndustries.slug,
  ROUTES.softwareDevelopmentForStartups.slug,
  ROUTES.softwareDevelopmentServicesForTechBusinesses.slug,
  ROUTES.roboticProcessAutomationServices.slug,
  CASE_STUDIES.aiBasedTravelPlanner,
  ROUTES.aiConsulting.slug,
  ROUTES.ragDevelopment.slug,
  CASE_STUDIES.warehouseAgent,
  ROUTES.mlOpsDevelopment.slug,
  NEW_PERSON.dmitry,
  NEW_PERSON.vlad,
  NEW_PERSON.sofia,
  NEW_PERSON.mikita,
  NEW_PERSON.yana,
  NEW_PERSON.lika,
  NEW_PERSON.nastassia,
  ROUTES.aiManagedPod.slug,
  ROUTES.aiEngineeringTransformation.slug,
  ROUTES.aiSecurity.slug,
  ROUTES.aiRoi.slug,
  ROUTES.aiAgenticOperations.slug,
  ROUTES.aiProductAcceleration.slug,
  ROUTES.assessments.slug,
];
